module.exports = __webpack_public_path__ + "img/clock-in-rest.aebc0f5f.png";